// [UbiBot Japan]お客様からの新しいメッセージ (姓名 - 公司 - 时间)

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

var wasSubmitted = false;
$("#applyForm").submit(function (e) {
  e.preventDefault(); // 阻止表单默认提交行为
  if (!wasSubmitted) {
    

    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var date = year + '-' + month + '-' + day + " " +  hour + ":" + minute;
    wasSubmitted = true;
  
    var companyName = $("#companyName").val();
    var deployment = $("#deployment").val();

    var industry = $('input[name="industry"]:checked').val();
    var industryText = $('label[for="' + industry + '"]').text();
    
    var zipcodeInput1 = $('#postalCode1').val();
    var zipcodeInput2 = $('#postalCode2').val();
    var zipcodeInput = zipcodeInput1 + zipcodeInput2;
    var prefecturesText = $('#prefectures option:selected').text();
    var residence = $("#residence").val();
    var name = $("#name").val();
    // var email = $("#email").val();
    var tel = $("#tel").val();
    var fax = $("#fax").val();

    var applicableitem = $('input[name="applicableitem"]:checked').val();
    var applicableitemText = $('label[for="' + applicableitem + '"]').text();
    var comments = $("#comments").val();
  
    var guidance = $('input[name="guidance"]:checked').val();
    var guidanceText = $('label[for="' + guidance + '"]').text();

    var dMFAX = $('input[name="dMFAX"]:checked').val();
    var dMFAXText = $('label[for="' + dMFAX + '"]').text();
    

    var email = $('#email').val().trim();
    if (!isValidEmail(email)) {
        alert('请输入有效的邮箱地址！');
        e.preventDefault(); // 阻止表单提交
    }

    var subject = `[UbiBot Japan]  IT導入事業者からの資料請求 (${name}- ユビボット - ${date})`
    var html_body = `<div style="color: #333;max-width: 600px;border:1px solid #ccc; padding: 20px; border-radius: 20px;">
        <div style="padding-bottom: 20px;border-bottom:1px solid #ccc;">
            <h4>IT導入事業者からの資料請求</h4>
        </div>
        <div style="padding-bottom: 15px;padding-top:20px;">
            <h4>Country Code</h4>
            <p>JP</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>Subject</h4>
            <p>${subject}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>会社名</h4>
            <p>${companyName}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>所属部署</h4>
            <p>${industryText}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>郵便番号</h4>
            <p>${zipcodeInput}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>都道府県</h4>
            <p>${prefecturesText}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>住所</h4>
            <p>${residence}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>お名前</h4>
            <p>${name}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>Eメール(半角英数字)</h4>
            <p>${email}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>TEL(半角数字)</h4>
            <p>${tel}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>FAX(半角数字)</h4>
            <p>${fax}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>該当する項目を選択してください</h4>
            <p>${applicableitemText}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>ご意見・ご要望</h4>
            <p>${comments}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>メールでのご案内</h4>
            <p>${guidanceText}</p>
        </div>
        <div style="padding-bottom: 15px;">
            <h4>DM／FAXでのご案内</h4>
            <p>${dMFAXText}</p>
        </div>
    </div>`
    $.ajax({
      type: 'POST',
      url: 'https://ubibot.zendesk.com/api/v2/requests.json', // 表单的action属性作为URL
      data:{
        "request": {
          "requester": {"name": name, "organization": prefecturesText, "residence": residence, "email": email, "phone": tel},
          "subject": subject,
          "comment": {"html_body": html_body }
        }
      }, //$(this).serializeArray(), // 自动序列化表单元素为字符串,
      success: function(data) {
        // 成功提交后的回调函数
        console.log('Form submitted successfully!');
        wasSubmitted = false;
        
        $(".custom-contact-successful-message").css('display', 'block');
        $("#applyForm").get(0).reset(); // 重置表单
      },
      error: function(xhr, textStatus, errorThrown) {
        wasSubmitted = false;
        $(".custom-contact-error-message").css('display', 'block');
        // 提交出错时的回调函数
        console.error('Submission failed: ' + xhr.responseText + ' - ' + errorThrown);
      }
    });
  }
  
});
